import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewChildren
} from '@angular/core';
import {BaseComponent} from "../base/base.component";
import {NgForm} from "@angular/forms";
import {Subscription} from "rxjs";
import {UserService} from "../../../core/services/user.service";
import {NotificationService} from "../../../core/services/notification.service";
import {CommonService} from "../../../core/services/common.service";
import {Message} from "../../../core/class/message";
import {ToastrService} from "ngx-toastr";
import {Router} from "@angular/router";
import {AuthenticationService} from "../../../core/services/authentication.service";
import {StorageService} from "../../../core/services/storage.service";
import {WarningComponent} from "../warning/warning.component";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-change-passsword-firsrt-time',
  templateUrl: './change-passsword-firsrt-time.component.html',
  styleUrls: ['./change-passsword-firsrt-time.component.scss']
})
export class ChangePassswordFirsrtTimeComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
  // Refer to form in view
  @ViewChild('f', { static: false }) ngForm: NgForm;
  // Subscribe to form changing
  formChangesSubscription: Subscription;
  // Whether the form change or not
  isFormChanging = false;
  checkEscKey = false;

  currentPasswordVisibility: boolean = false;
  newPasswordVisibility: boolean = false;
  confirmPasswordVisibility: boolean = false;

  passwordData = {
    newPassword: null,
    confirmPassword: null
  }
  isFocusNewPassword = false;

  strengthPattern = '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[~!@#$%^&*()_+|`={}[\\\]:<;?>,."\'/-]).{1,}$';

  @ViewChildren('focusInput') focusInput;

  userType: number;

  constructor(
    private userService: UserService,
    private el: ElementRef,
    public dialogRef: MatDialogRef<ChangePassswordFirsrtTimeComponent>,
    private dialog: MatDialog,
    public notificationService: NotificationService,
    public commonService: CommonService,
    public message: Message,
    private toastr: ToastrService,
    private router: Router,
    private auth: AuthenticationService,
    private storage: StorageService
  ) {
    super(commonService, message);
    dialogRef.disableClose = true;
    dialogRef.backdropClick().subscribe(_ => {
      // this.cancel();
    });

    this.userType = storage.getUserTypeFromSessionStorage();
  }

  @HostListener('submit')
  onFormSubmit() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.mat-form-field-invalid .mat-input-element,.mat-select-invalid');
    if (invalidElements.length > 0) {
      invalidElements[0].focus();
    }
  }

  @HostListener('document:keydown.escape', ['$event'])
  onKeydownHandler(event: KeyboardEvent) {
    if (!this.checkEscKey) {
      this.cancel();
    }
  }

  /**
   * On After Init
   */
  ngAfterViewInit() {
    setTimeout(_ => this.focusInput.first.nativeElement.focus(), 200);

    this.formChangesSubscription = this.ngForm.valueChanges.subscribe(() => {
      if (this.ngForm.dirty) {
        this.isFormChanging = true;
      }
    });
  }

  /**
   * Implement ngOnDestroy method, unsubscribe error service to avoid memory leak
   */
  ngOnDestroy() {
    this.formChangesSubscription.unsubscribe();
    this.notificationService.unsubscribeErrorService();
  }

  /**
   * Close pop-up
   */
  cancel() {
    if (this.isFormChanging) {
      this.checkEscKey = true;
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: 'messages.confirm_change_data'
      });
      dialogRe.afterClosed().subscribe(result => {
        if (result) {
          this.dialogRef.close();
        }
        dialogRe.close();
        this.checkEscKey = false;
      });
    } else {
      this.dialogRef.close();
    }
  }

  enableFocus = true;

  clickVisibility(){
    console.log("click")
    this.enableFocus = false;
    this.newPasswordVisibility = !this.newPasswordVisibility;
    setTimeout(() => {
      this.enableFocus = true;

    }, 700)
  }


  isTouch = false;

  onFocus(){
    this.isTouch = true;
    if(!this.enableFocus){
      return
    }
    console.log("focus")
    setTimeout(() => {
      this.isFocusNewPassword = true;
    }, 150)
  }

  onBlur(){
    if(!this.enableFocus){
      return
    }
    console.log("blur")
    setTimeout(() => {
      this.isFocusNewPassword = false;
    }, 150)
  }

  changePassword() {
    this.userService.changePasswordFirstTime(this.passwordData).subscribe((rs) => {
      if (rs && rs.success) {
        this.toastr.success(
          this.message.getMessage("change_password.change_pass_success")
        );
        this.notificationService.emitChangePassword(true);
        localStorage.setItem('lastChangePassword', new Date().toISOString());
        this.dialogRef.close();
        // this.auth.logout();
      } else if (rs && !rs.success) {
        if (rs.code == "0x00126") {
          setTimeout(
            (_) => this.focusInput.first.nativeElement.focus(),
            200
          );
          this.toastr.error(
            this.message.getMessage("change_password.change_pass_error")
          );
        } else if (rs.code == "0x002436") {
          setTimeout(
            (_) => this.focusInput.first.nativeElement.focus(),
            200
          );
          this.toastr.error(
            this.message.getMessage(rs.message)
          );
        } else if (rs.code == "0x00115") {
          setTimeout(
            (_) => this.focusInput.first.nativeElement.focus(),
            200
          );
          this.toastr.error(
            rs.data.newPassword
          );
        } else {
          setTimeout(
            (_) => this.focusInput.first.nativeElement.focus(),
            200
          );
          if (rs.message)
            this.toastr.error(
              this.message.getMessage(rs.message)
            );
        }
      }
    }, error => {
      this.message.getMessage(error.error.message)
    });
  }

  ngOnInit(): void {
  }
}
